export default __webpack_public_path__ + "static/media/Example-Trust_Acct.6a05d81b.png";